export { default } from "./linkHeap";
